module.exports = __webpack_public_path__ + "img/logo-nav.65e7207f.png";